import config from "config/config";
import { getToken } from "js/formatting/getToken";
export async function unlockUser(userId) {
  console.log(userId);

  let options = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `bearer ${getToken()}`,
    },
    body: JSON.stringify({
      userId: userId,
    }),
  };

  const response = await fetch(
    config.REG_API_BASE_URL + "/User/unlock",
    options
  );
  if (!response.ok) {
    const data = await response.json();
    if (
      response.status === 401 &&
      data?.errors[0]?.description === "Token Invalid or Expired"
    ) {
      throw response;
    } else {
      if (
        response.status === 404 ||
        response.status === 403 ||
        response.status === 401
      ) {
        return response.json();
      } else {
        throw response;
      }
    }
  } else {
    //const data = await response.json();
    return response;
  }
}
